export const SHIFT_CHANGES_TYPES = {
  TIME_ADJUSTMENT: 'time_adjustment',
  LEAVE: 'leave',
};
